import axios from "axios";
import {
    clearSession,
    csrfHeaders,
    refreshSessionIfNeeded,
} from "./src/auth.js";

axios.interceptors.request.use(
    async function (config) {
        config.withCredentials = true;
        await refreshSessionIfNeeded();

        if (!["get", "head", "options"].includes(config.method?.toLowerCase())) {
            Object.assign(config.headers, csrfHeaders());
        }

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
)


axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        console.log("response error", error);
        if (error.response && error.response.status === 401) {
            clearSession();
            window.dispatchEvent(new CustomEvent("auth-expired"));
        } else if (error.response && error.response.status === 403) {
            console.error("The request was rejected by CSRF protection.");
        }
        return Promise.reject(error);
    },
);

const APIService = () => {
    const get = async (url, config = {}) => {
        try {
            return await axios.get(`${url}`, config);
        } catch (error) {
            console.error("GET error:", error);
            throw error;
        }
    };

    const post = async (url, data, config = {}) => {
        try {
            return await axios.post(`${url}`, data, config);
        } catch (error) {
            console.error("POST error:", error);
            throw error;
        }
    };

    return {
        get,
        post,
    };
};

export default APIService();